module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, _vm._l((_vm.contenidos), function(item, index) {
    return _c('v-flex', {
      key: 'button-expand' + index,
      staticClass: "expand-flex-container",
      attrs: {
        "xs12": "",
        "sm6": "",
        "md4": ""
      }
    }, [_c('div', {
      staticClass: "button-expand-cont"
    }, [_c('button', {
      staticClass: "button-expand back-red hvr-grow",
      on: {
        "mouseover": function($event) {
          _vm.showText(index, item)
        },
        "click": function($event) {
          _vm.showText(index, item)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.nombre) + "\n        ")]), _vm._v(" "), (item.visto) ? _c('div', {
      staticClass: "expand-text light-dark-int animated fadeInDown"
    }, [_c('p', {
      attrs: {
        "role": "alert"
      },
      domProps: {
        "innerHTML": _vm._s(item.texto)
      }
    })]) : _vm._e()])])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ed31f9e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/ButtonExpandCont.vue
// module id = 946
// module chunks = 1